import { useState } from 'react'
import TextGradient from '@app/components/gradient/gradient-text'
import Input from '@app/components/form/input'
import PhoneInput from '@app/components/phone-input'
import TextArea from '@app/components/text-area'
import Checkbox from '@app/components/checkbox'
import Button from '@app/components/button'

import { mdiMapMarkerOutline, mdiEmail } from '@mdi/js'
import Icon from '@mdi/react'
import { Form } from 'react-final-form'
import { toast } from "react-toastify";

import { frontendApi } from "@app/lib/api";

const ContactUs = () => {
  const [isDisabled, setIsDisabled] = useState(true)

  const handleSubmit = async (payload, form) => {
    await frontendApi.post('/web/get-in-touch', payload)
      .then((res) => {
        console.log(payload)
        toast.success(res.data.message, { position: "bottom-right" });
        form.reset()
        setIsDisabled(true)
      })
      .catch((err) => toast.error('Something went wrong'))
  }

  return (
    <div className="md:flex">
      <div className="bg-background-low-em pt-10 pb-6 px-6 md:basis-1/2 md:pt-44 md:px-10 xl:!px-20">
        <div className="space-y-2">
          <p className="label-sm text-secondary-dark">Contact Us</p>
          <TextGradient overrideClassName="h5 sm:h4 md:h3">
            Message our friendly team
          </TextGradient>
          <p className="text-body-lg text-text-color-mid-em">
            We&apos;d love to hear from you! Please get in touch.
          </p>
        </div>
        <div className="space-y-6 mt-6">
          <div className="flex space-x-4">
            <Icon path={mdiMapMarkerOutline} size={1} className="text-secondary-dark" />
            <div>
              <p className="label-lg text-text-color-mid-em">Plano, TX</p>
              <p className="label-sm text-text-color-low-em">Visit our Headquarters Office.</p>
            </div>
          </div>
          <div className="flex space-x-4">
            <Icon path={mdiEmail} size={1} className="text-secondary-dark" />
            <div>
              <p className="label-lg text-text-color-mid-em break-all">contact@simplewaste.com</p>
              <p className="label-sm text-text-color-low-em">Speak to our friendly team</p>
            </div>
          </div>
        </div>
      </div>
      <div className="p-6 md:basis-1/2 md:py-[70px] md:px-10 xl:py-[90px] xl:px-[120px]">
        <div className="space-y-4">
          <h5 className="text-text-color-high-em h5 md:h4">Get in touch</h5>
          <p className="text-body-lg text-text-color-mid-em">
            Got a question? Send us a message and we&apos;ll respond as soon as possible.
          </p>
        </div>
        <div className="mt-4 space-y-6 flex flex-col justify-center">
          <Form
            onSubmit={handleSubmit}
            render={({
              handleSubmit, form, submitting,
            }) => (
              <form onSubmit={handleSubmit} className="space-y-6">
                <Input label="Name" name="name" />
                <Input label="Company" name="company" />
                <Input label="Email" name="email" />
                <PhoneInput
                  initialValue="us"
                  name="phone"
                  label="Phone Number"
                  labelClassName="text-text-color-high-em label-md"
                />
                <TextArea label="Message" name="message" labelClassName="text-text-color-high-em label-md" />
                <Checkbox
                  checked={!isDisabled}
                  onChange={(e) => setIsDisabled(!e.target.checked)}
                  description="You agree to our friendly privacy policy."
                />
                <Button type="submit" className="w-full" disabled={isDisabled}>Send Message</Button>
              </form>
            )}
          />

        </div>
      </div>
    </div>
  )
}

export default ContactUs